export default __webpack_public_path__ + "static/media/5000_it.3d63a649.ods";